import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from '../../../../hocs';
import {
  AdminDialogTitle,
  AdminDialogContent,
  AdminDialogControls,
  PrimaryButton,
  AdminDialog,
  Spinner,
  ErrorBox,
} from '../../../../components/index';
import EntityForm from './EntityForm/EntityForm';
import { COLORS } from '../../../../helpers';
import { apiProducerPaymentSettingsAddBankAccount } from '../../../../api';

const styles = {
  wrapper: {},
  name: {
    fontSize: 18,
    fontFamily: "'Roboto', sans-serif",
    color: COLORS.text,
    marginBottom: 40,
  },
  input: {
    marginBottom: 25,
  },
  label: {
    fontSize: 14,
  },
  title: {
    fontSize: 18,
    textTransform: 'capitalize',
  },
  inputText: {
    textAlign: 'right',
  },
  button: {
    minWidth: 330,
    alignSelf: 'center',
    textTransform: 'uppercase',
  },
  controls: {
    margin: '27px 0 0 0',
    textAlign: 'center',
  },
  control: {
    padding: '0 105px',
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
  },
  column: {
    flex: 1,
  },
};

const propTypes = {
  entity: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  onDone: PropTypes.func.isRequired,
};

class Dialog extends React.Component {
  state = {
    loading: false,
    error: '',
  };

  constructor(props) {
    super(props);
    this.entity = null;
  }

  validate = () => {
    const { onDone } = this.props;
    const entity = this.entity.validate();
    if (entity.validated) {
      this.setState({
        loading: true,
        error: '',
      });

      let data = {
        ...entity.data,
      };

      apiProducerPaymentSettingsAddBankAccount(
        data,
        (settings) => {
          onDone(settings);
        },
        (error) => {
          if (error.response.data.code === 9100) {
            this.setState({
              error: error.response.data.message,
              loading: false,
            });
          } else {
            this.setState({
              loading: false,
            });
          }
        }
      );
    }
  };

  componentWillUnmount() {
    this.entity = null;
  }

  render() {
    const { intl, classes, entity, onClose } = this.props;

    return (
      <AdminDialog open closeButton onClose={onClose}>
        <AdminDialogTitle title={intl.formatMessage({ id: 'producer.dialog.addingBankAccount' })} />
        <AdminDialogContent className={classes.wrapper}>
          {this.state.loading && <Spinner size={60} />}
          {this.state.error && <ErrorBox error={this.state.error} />}

          <EntityForm data={entity} onRef={(entity) => (this.entity = entity)} />

          <AdminDialogControls>
            <PrimaryButton className={classes.button} onClick={this.validate}>
              {intl.formatMessage({ id: 'global.save' })}
            </PrimaryButton>
          </AdminDialogControls>
        </AdminDialogContent>
      </AdminDialog>
    );
  }
}

Dialog.propTypes = propTypes;

export default withRouter(withStyles(styles, { withTheme: true })(injectIntl(Dialog)));
